import { useGrowthABExperimentsState } from 'hooks/useAssignGrowthABGroups';
import { GrowthExperimentsEnum, ABTest } from 'types/growthExperiments.types';

/**
 * Hook to determine if the user is in the new activation flow experiment group
 *
 * Group A = control group (old WalletOnboarding flow)
 * Group B = experiment group (new UnifiedActivationFlow)
 *
 * @returns boolean - true if user is in Group B (should see new activation flow)
 */
export const useIsInActivationFlowExperiment = (): boolean => {
  const { experiments } = useGrowthABExperimentsState();

  return (
    experiments[GrowthExperimentsEnum.ACCOUNTABLE_BANKING_ACTIVATION] ===
    ABTest.B
  );
};
